module.exports = __webpack_public_path__ + "../resources/graphql/schema.all.min-512575e1d4726320cd172dcbbefb7544.graphql";